import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** The ink is shiny blob voxels, as Oozery's goo: every colour flows in the one sim and fuses into one surface. */
export const OOZE_PEN_LIQUID = liquidKind('blob', { material: 'shiny' })

/** One frame of a line's goo (laid, fallen, slumped): a press is one undo step. */
export const OOZE_PEN_SETTLE = liquidSettleEvent('experience.ooze-pen.settle', OOZE_PEN_LIQUID)

/** Reducer handlers for Ooze pen (`experience.ooze-pen.*`). */
export const eventHandlers = OOZE_PEN_SETTLE.handlers
